export default "__VITE_ASSET__BVUt6UQG__"